import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function RightHeadedArrowIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M23.8421 12.141A.493.493 0 0 1 24 12.5a.493.493 0 0 1-.1579.359l-6.4002 5.9944c-.2101.1972-.5483.1951-.7542-.0041-.208-.1982-.2048-.5177.0032-.7149l5.4388-5.0927H.5417a.5417.5417 0 1 1 0-1.0834h21.588l-5.4388-5.0927c-.208-.1962-.2112-.5157-.0032-.715.2059-.1991.5441-.2012.7542-.004l6.4002 5.9944Z"/>
    </SvgIcon>
  )
}

export default RightHeadedArrowIcon
